import * as React from "react";
import type { SVGProps } from "react";
const SvgUpcomingRenewal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    fill="none"
    viewBox="0 0 17 16" {...props}
  >
    <path
      stroke="#ED8822"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m15.071 8-1.334 1.333L12.403 8"
    />
    <path
      stroke="#ED8822"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.627 4.23a5.335 5.335 0 0 1 9.11 3.772c0 .406-.049.8-.134 1.179M1.727 7.997l1.335-1.333 1.334 1.333"
    />
    <path
      stroke="#ED8822"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.172 11.77a5.335 5.335 0 0 1-9.11-3.772c0-.405.049-.798.134-1.178"
    />
  </svg>
);
export default SvgUpcomingRenewal;
